module.exports = __webpack_public_path__ + "img/seal3.307f95ac.png";